'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import { CustomRegistration } from '@components/CustomRegistration';
import CommonContainer from '@components/CommonContainer';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import { fadeUpAosProps, getAosDelay, mergeAos } from '@utils/aosProps';
import {
  DesktopBreakpoint,
  MobileBreakpoint,
  TabletBreakpoint,
} from '@components/Breakpoints';

import cn from './style.module.scss';
export const AL_GHADEER_REGISTRATION_ID = 'alGhadeerRegistration';
export default function AlGhadeerRegistration(props: any) {
  const registrationSection = props?.locale?.section?.find(
    (section: any) => section.type === 'registration' && section.enabled
  );
  if (!registrationSection) return null;
  const { links, leadConfig } = props;
  return (
    <Stack
      component="section"
      className={cn.alGhadeerRegistrationWrapper}
      id={AL_GHADEER_REGISTRATION_ID}
    >
      <Box className={cn.alGhadeerRegistrationInner}>
        <CommonContainer
          maxWidth={{ xs: '100%', md: '100%', lg: '100%' }}
          paddingInline={{ xs: '1.25rem', md: '5%', lg: '10%' }}
          flexGrow={1}
        >
          <Box className={cn.alGhadeerRegistrationBody}>
            <Box className={cn.alGhadeerRegistrationContent}>
              <Box className={cn.alGhadeerRegistrationContent__title}>
                <MobileBreakpoint>
                  <ParallaxText
                    variant="h2"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      registrationSection?.alghadeerRegistrationHeadingMobile
                    )}
                  </ParallaxText>
                </MobileBreakpoint>
                <TabletBreakpoint>
                  <ParallaxText
                    variant="h2"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      registrationSection?.alghadeerRegistrationHeadingDesktop
                    )}
                  </ParallaxText>
                </TabletBreakpoint>
                <DesktopBreakpoint>
                  <ParallaxText
                    variant="h2"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      registrationSection?.alghadeerRegistrationHeadingDesktop
                    )}
                  </ParallaxText>
                </DesktopBreakpoint>
              </Box>
              <Box className={cn.alGhadeerRegistrationContent__data}>
                <MobileBreakpoint>
                  <ParallaxText
                    variant="p"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      registrationSection?.alghadeerRegistrationDataMobile
                    )}
                  </ParallaxText>
                </MobileBreakpoint>
                <TabletBreakpoint>
                  <ParallaxText
                    variant="p"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      registrationSection?.alghadeerRegistrationDataTablet
                    )}
                  </ParallaxText>
                </TabletBreakpoint>
                <DesktopBreakpoint>
                  <ParallaxText
                    variant="p"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      registrationSection?.alghadeerRegistrationDataDesktop
                    )}
                  </ParallaxText>
                </DesktopBreakpoint>
              </Box>
            </Box>
            <Box className={cn.alGhadeerRegistrationForms}>
              <Box className={cn.alGhadeerFormsElement}>
                <CustomRegistration
                  t={registrationSection}
                  successPopUpLink={links.successPopupRedirection}
                  privacyPolicyLink={links.privacyPolicy}
                  termsAndConditionsLink={links.termsAndConditions}
                  formId={leadConfig.formId}
                  formType={leadConfig.formType}
                  projectName={leadConfig.projectName}
                  theme="dark"
                  variant="modal"
                  className={cn.alGhadeerRegistrationOuter}
                  listClassName={cn.alGhadeerRegistrationList}
                  blockClassName={cn.alGhadeerRegistrationBlock}
                  inputClassName={cn.alGhadeerRegistrationInput}
                  elementClassName={cn.alGhadeerRegistrationElement}
                  submitBlockClassName={cn.alGhadeerRegistrationSubmitBlock}
                  submitClassName={cn.alGhadeerRegistrationButton}
                  marksClassName={cn.alGhadeerRegistrationMarks}
                  authClassName={cn.alGhadeerRegistrationAuthentication}
                  validationClassName={cn.alGhadeerRegistrationValidation}
                  wrapperClassName={cn.alGhadeerRegistrationSuccessWrapper}
                  contentClassName={cn.alGhadeerRegistrationSuccessContent}
                  buttonClassName={cn.alGhadeerRegistrationSuccessButton}
                />
              </Box>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
